import React from "react";
import PropTypes from "prop-types";
import CopyButton from "./CopyButton";

const InternalRow = ({ id, heading, text, hasCopyButton, isConcealed }) => (
  <li id={id} className="lfc-internal-row">
    {heading && <span className="lfc-internal-heading">{heading}</span>}
    <div className="lfc-internal-text-container">
      <span className="lfc-internal-text">
        {isConcealed ? "(concealed)" : text}
      </span>
      {hasCopyButton && (
        <CopyButton
          className="lfc-copy-button"
          toClipboard={text}
          text="copy"
        />
      )}
    </div>
  </li>
);

InternalRow.defaultProps = {
  heading: null,
  hasCopyButton: false,
  isConcealed: false
};

InternalRow.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.string,
  text: PropTypes.string.isRequired,
  hasCopyButton: PropTypes.bool,
  isConcealed: PropTypes.bool
};

export default InternalRow;
